const BASE = "";

export interface CheckResult {
  success: boolean;
  isNewUser?: boolean;
  prefill?: { name: string; stage: string; wechat: string };
  error?: string;
}

export interface AuthResult {
  success: boolean;
  token?: string;
  user?: {
    name: string;
    stage: string;
    wechat: string;
    role: string;
  };
  error?: string;
}

export async function checkName(name: string): Promise<CheckResult> {
  const res = await fetch(`${BASE}/api/auth/check`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name })
  });
  return res.json() as Promise<CheckResult>;
}

export async function setupAccount(
  name: string, initPassword: string, newPassword: string,
  stage: string, wechat: string
): Promise<AuthResult> {
  const res = await fetch(`${BASE}/api/auth/setup`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, initPassword, newPassword, stage, wechat })
  });
  return res.json() as Promise<AuthResult>;
}

export async function login(name: string, password: string): Promise<AuthResult> {
  const res = await fetch(`${BASE}/api/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, password })
  });
  return res.json() as Promise<AuthResult>;
}

export async function getMe(): Promise<AuthResult> {
  const token = localStorage.getItem("rc_token");
  const res = await fetch(`${BASE}/api/auth/me`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.json() as Promise<AuthResult>;
}

export async function changePassword(oldPassword: string, newPassword: string): Promise<{ success: boolean; error?: string }> {
  const token = localStorage.getItem("rc_token");
  const res = await fetch(`${BASE}/api/auth/password`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ oldPassword, newPassword })
  });
  return res.json() as Promise<{ success: boolean; error?: string }>;
}
